import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f8dd1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19.9998 0.95929C19.1639 0.967102 18.4498 1.2671 17.8592 1.85929L12 7.72009L6.14075 1.85929C5.55011 1.26709 4.83607 0.96709 4.00011 0.95929C3.16419 0.967102 2.45011 1.2671 1.85947 1.85929C1.26727 2.44993 0.967273 3.16397 0.959473 3.99993C0.967285 4.83585 1.26728 5.54993 1.85947 6.14057L7.72027 11.9998L1.85947 17.859C1.26727 18.4496 0.967273 19.1637 0.959473 19.9996C0.967285 20.8355 1.26728 21.5496 1.85947 22.1403C2.45011 22.7325 3.16415 23.0262 4.00011 23.0199C4.83603 23.0262 5.55011 22.7324 6.14075 22.1403L12 16.2795L17.8592 22.1403C18.4498 22.7325 19.1638 23.0262 19.9998 23.0199C20.8357 23.0262 21.5498 22.7324 22.1404 22.1403C22.7326 21.5496 23.0264 20.8356 23.0201 19.9996C23.0264 19.1637 22.7326 18.4496 22.1404 17.859L16.2796 11.9998L22.1404 6.14057C22.7326 5.54993 23.0264 4.83589 23.0201 3.99993C23.0264 3.16401 22.7326 2.44993 22.1404 1.85929C21.5498 1.26709 20.8358 0.96709 19.9998 0.95929Z" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "notification",
    duration: "200"
  }, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`notification ${_ctx.variant} ${_ctx.kind}`),
            "aria-role": "alert"
          }, [
            _createElementVNode("section", null, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            (_ctx.isClosable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-generic p-2 bg-white bg-opacity-50 hover:bg-gray-200 bg-blend-multiply hover:bg-opacity-80",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, _hoisted_2))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}